<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<p style="text-align: center; font-family: Times New Roman; padding-top:60px; padding-bottom:10px; font-size:30px; letter-spacing:1px; font-weight:normal;">ACKNOWLEDGEMENTS</p>
<p style="text-align: center;"> <img alt="line" src="media/line.png"/></p>
<p><br/><br/><br/>I would like to thank the following people who have played a part in the making of this book:</p>
<p>My mother and father, Gerry and Philip McMinn, the very first ‘Humpy’ and ‘Dumpy’, who are probably puzzled as to which side of the family to ascribe the personal details described in this book.</p>
<p>My siblings Hilary, Kevin, Stuart and Clive, and my niece Catherine and nephew Sam, who stuck with me through thick and thin.</p>
<p>My aunts Bren and Joan and my uncle, Barry, who have always ‘been there for me’.</p>
<p>The Rt Revd Richard Chartres, Bishop of London, for allowing me to quote him in the preface.</p>
<p>Lady ‘Chaterley’ who listened to my insane ideas and endless ramblings, but affirmed me all the way.</p>
<p>Jan and Nigel Skelsey, who gave me ‘permission to push the boat out’.</p>
<p>Gary Johnstone and Rob Lindsell, who have been great fellow-travellers.</p>
<p>Jackie, Marcelle and Philip Huber, who were there when the Send button was pushed.</p>
<p>Dr Luke Mitcheson, who never stopped listening and listening.</p>
<p>Andrew Kavalierou, who gave me a taste of restored self-belief.</p>
<p>Dr Robin Lawrence, who made 4 p.m. sessions an epiphany.</p>
<p>Tim Goodwin, who urged me on and not to flag.</p>
<p>Simon Buchanan, who gave me my first computer.</p>
<p>Tom and Chrissie Cockburn, whose support provided more fuel to my fire.</p>
<p>Daniel Holt, for sitting with me for hours whilst we designed the cover.</p>
<p>And finally, to the wonderful Lucy Edyvean, who first edited this book and was crucial in the final stages. I cannot ever, ever, ever imagine this book without her. Nor the sequels!</p>
<p>I want to thank the following people who have supported me financially with the self-publishing and marketing costs:</p>
<p>John Baksi, Sue and Will Ballantyne, Elsa and Henning Brathaug, James Bromiley-Davis, Mima Chater (aka Lady Chaterly), Mike Docker, Bob Edwards, Lucy Edyvean, Tim Goodwin, Joan and Barry Holt, Nick and Sarah Holt, Hilary and Peter Hyson, Rob and Nell Lindsell, Jax Huber, Tom and Miranda Dunn, Clive and Glenda McMinn, Geoff, Sam and Catherine Rowland, Evania Royland, Nic Shearer, Justin, Anna and Bubble Walford, Angela Warwick Haller.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?1b6b5368